import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import Karnak from './Karnak';

const container = document.getElementById('karnak');
const root = createRoot(container);

const router = createBrowserRouter([
  {
    path: '*',
    element: <Karnak />,
  },
]);

root.render(<RouterProvider router={router} />);

if (module.hot) {
  module.hot.accept();
}
